import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { IconSize } from '@stylehaven/components';

@Component({
    selector: 'med-tag-suggestions',
    templateUrl: './tag-suggestions.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TagSuggestionsComponent {
    public readonly IconSize: typeof IconSize = IconSize;

    @Input() noTagsMessage = '';
    @Input() tags: string[] = [];

    @Output() tagAccepted: EventEmitter<string> = new EventEmitter<string>();
    @Output() tagDeclined: EventEmitter<string> = new EventEmitter<string>();

    public onAccept(tag: string): void {
        this.tagAccepted.emit(tag);
    }

    public onRemove(tag: string): void {
        this.tagDeclined.emit(tag);
    }
}
